module.exports = __webpack_public_path__ + "images/柏纳s长图_02.jpg?v=cc756595";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_02.jpg
 ** module id = 157
 ** module chunks = 1 2
 **/